import { Component } from '@angular/core';
import { PageTitleService } from '../../services/page-title.service';

@Component({
  selector: 'psc-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {

  constructor(
    private pageTitleService: PageTitleService,
  ) {
    /**
     * t(title.not-found)
     */
    this.pageTitleService.setTitle('title.not-found');
  }
}
